/**
 * @file pipes.module.ts
 */
import { NgModule } from '@angular/core';
import { ContactPipe } from './contact.pipe';
import { CommonModule } from '@angular/common';
import { PhoneNumberPipe } from './fomatPhone.pipe';
import { HighlightSearch } from './highlightText.pipe';
import { SanitizeHtmlPipe } from './sanitize-html.pipe';

@NgModule({
  declarations: [ContactPipe, PhoneNumberPipe, HighlightSearch, SanitizeHtmlPipe],
  imports: [CommonModule],
  exports: [ContactPipe, PhoneNumberPipe, HighlightSearch, SanitizeHtmlPipe],
})
export class PipesModule {}
